"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _Cart = require("Cart");

var _class, _descriptor, _temp;

var CartPage = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CartPage, _Component);

  function CartPage() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CartPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CartPage)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "content", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CartPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        "data-cart-page": "true"
      }, _react.default.createElement(_Cart.CartPage, this.content)));
    }
  }]);
  return CartPage;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = CartPage;